import React from 'react';
import type { NodeStatus } from '@/data/kavrisData';

interface StatusBadgeProps {
  status: NodeStatus;
  size?: 'xs' | 'sm' | 'md';
  showDot?: boolean;
}

const statusConfig: Record<NodeStatus, { label: string; dotClass: string; bgClass: string; textClass: string }> = {
  Approved: {
    label: 'Approved',
    dotClass: 'bg-[#22c55e]',
    bgClass: 'bg-status-approved',
    textClass: 'status-approved',
  },
  Working: {
    label: 'Working',
    dotClass: 'bg-primary',
    bgClass: 'bg-status-working',
    textClass: 'status-working',
  },
  Draft: {
    label: 'Draft',
    dotClass: 'bg-[#f59e0b]',
    bgClass: 'bg-status-draft',
    textClass: 'status-draft',
  },
  Experimental: {
    label: 'Experimental',
    dotClass: 'bg-[#a855f7]',
    bgClass: 'bg-status-experimental',
    textClass: 'status-experimental',
  },
  Prototype: {
    label: 'Prototype',
    dotClass: 'bg-muted-foreground',
    bgClass: 'bg-status-prototype',
    textClass: 'status-prototype',
  },
};

export default function StatusBadge({ status, size = 'sm', showDot = true }: StatusBadgeProps) {
  const config = statusConfig[status];
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[10px] gap-1',
    sm: 'px-2 py-0.5 text-[11px] gap-1.5',
    md: 'px-2.5 py-1 text-xs gap-1.5',
  };
  const dotSizes = {
    xs: 'w-1 h-1',
    sm: 'w-1.5 h-1.5',
    md: 'w-2 h-2',
  };

  return (
    <span
      className={`inline-flex items-center rounded font-mono-data font-medium tracking-wide border border-transparent ${sizeClasses[size]} ${config.bgClass} ${config.textClass}`}
      style={{ borderColor: 'rgba(255,255,255,0.06)' }}
    >
      {showDot && (
        <span className={`rounded-full flex-shrink-0 ${dotSizes[size]} ${config.dotClass}`} />
      )}
      {config.label}
    </span>
  );
}